import { Component, computed, inject, Signal } from '@angular/core';
import { CombinedStore } from 'src/app/core/combined.store';
import { PathType } from 'src/app/shared/enum/path-type.enum';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';
import { SvgViewerComponent } from '../svg-viewer/svg-viewer.component';

@Component({
  selector: 'app-advisor-journey-banner',
  standalone: true,
  templateUrl: './advisor-journey-banner.component.html',
  imports: [SvgViewerComponent]
})
export class AdvisorJourneyBannerComponent {
  private readonly store = inject(CombinedStore);

  // In SA we only have one product, so we can hardcode the message for now. In the future, if we add more products, we can use a similar approach to the one used in the previous version of this component.
  protected readonly message: Signal<string> = computed(
    () => 'Santé Animale',
  );

  svg = new SvgVM('assets/common/toast/info_reverse.svg', 'Advisor Journey Banner');
}
